import { Fade, Modal } from '@mui/material';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import GeniusHsnMaster from './geniusHsnMaster';
import ModalHeaderStyle from '../utility/component/styles/modalHeaderStyle';
import {
  selectHsnMasterStatus,
  setHsnMasterStatus,
} from '../utility/Redux/modal';
import ModalBody from '../utility/component/styles/modalBody';
import './masterModern.css';

const HsnMaster = () => {
  const dispatch = useDispatch();
  const ModalStatus = useSelector(selectHsnMasterStatus);

  const handleClose = () => {
    dispatch(setHsnMasterStatus(false));
  };

  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: window.innerWidth <= 768 ? '95%' : 'min(760px, 92vw)',
    height: 'auto',
    backgroundColor: 'transparent',
    borderRadius: '12px',
    border: '0px solid transparent',
  };

  return (
    <div>
      <Modal
        open={ModalStatus}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Fade in={ModalStatus}>
          <div style={style} className="modern-master-modal">
            <div className="w-full flex flex-col bg-white h-full ">
              <ModalHeaderStyle header={'HSN Master'} onClose={handleClose} />

              <ModalBody><div className="modern-master-modal-viewport">
                <GeniusHsnMaster />
              </div></ModalBody>
            </div>
          </div>
        </Fade>
      </Modal>
    </div>
  );
};

export default HsnMaster;
